1/**
 * AdminEspecializadoLayout — Layout próprio para admins especializados de diligência.
 *
 * Usa sidebar enxuta e header contextualizado por especialidade.
 * Completamente separado do AdminLayout do admin principal.
 */

import React from 'react';
import { BaseLayout, type BaseLayoutConfig } from './BaseLayout';
import { AdminEspecializadoSidebar } from './AdminEspecializadoSidebar';
import { useDiligenciaPermissions } from '@/features/diligencias/hooks';
import { getEspecialidadeConfig } from '@/utils/adminEspecializadoConfig';

interface AdminEspecializadoLayoutProps {
  children: React.ReactNode;
}1

export const AdminEspecializadoLayout: React.FC<AdminEspecializadoLayoutProps> = ({ children }) => {
  const { especialidade } = useDiligenciaPermissions();
  const config = getEspecialidadeConfig(especialidade);

  const layoutConfig: BaseLayoutConfig = {
    headerVariant: 'full',
    headerTitle: config?.painelTitulo ?? 'Painel Especializado',
    showNotifications: true,
    background: 'gray',
    bottomNavRole: 'admin',
  };

  return (
    <BaseLayout
      sidebar={<AdminEspecializadoSidebar />}
      config={layoutConfig}
    >
      {children}
    </BaseLayout>
  );
};
